var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloudy = function SvgCloudy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sun (1) 1",
    clipPath: "url(#clip0_5107_207618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5107_207618",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.841797 0.470703H16.8418V16.4707H0.841797V0.470703Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5107_207618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.15841 1.73376C7.15841 1.73376 7.15841 0.891652 8.00051 0.891652C8.84262 0.891652 8.84262 1.73376 8.84262 1.73376V2.57586C8.84262 2.57586 8.84262 3.41797 8.00051 3.41797C7.15841 3.41797 7.15841 2.57586 7.15841 2.57586V1.73376ZM13.8953 6.78639C13.8953 6.78639 14.7374 6.78639 14.7374 7.62849C14.7374 8.4706 13.8953 8.4706 13.8953 8.4706H13.0531C13.0531 8.4706 12.211 8.4706 12.211 7.62849C12.211 6.78639 13.0531 6.78639 13.0531 6.78639H13.8953ZM2.94788 6.78639C2.94788 6.78639 3.78999 6.78639 3.78999 7.62849C3.78999 8.4706 2.94788 8.4706 2.94788 8.4706H2.10578C2.10578 8.4706 1.26367 8.4706 1.26367 7.62849C1.26367 6.78639 2.10578 6.78639 2.10578 6.78639H2.94788ZM4.5782 3.43649C4.5782 3.43649 5.17357 4.03186 4.5782 4.62723C3.98283 5.2226 3.38746 4.62723 3.38746 4.62723L2.79167 4.03186C2.79167 4.03186 2.1963 3.43649 2.79167 2.8407C3.38746 2.24534 3.98283 2.8407 3.98283 2.8407L4.5782 3.43649ZM12.614 4.62681C12.614 4.62681 12.0186 5.22218 11.4233 4.62681C10.8279 4.03144 11.4233 3.43607 11.4233 3.43607L12.0186 2.8407C12.0186 2.8407 12.614 2.24534 13.2094 2.8407C13.8047 3.43607 13.2094 4.03144 13.2094 4.03144L12.614 4.62681ZM11.79 7.62849C11.79 6.62346 11.3907 5.6596 10.6801 4.94893C9.96941 4.23827 9.00555 3.83902 8.00051 3.83902C7.25103 3.83902 6.51837 4.06127 5.8952 4.47766C5.27202 4.89405 4.78631 5.48589 4.4995 6.17833C4.21268 6.87076 4.13764 7.6327 4.28385 8.36778C4.43007 9.10287 4.79098 9.77809 5.32095 10.3081C5.85092 10.838 6.52614 11.1989 7.26122 11.3452C7.99631 11.4914 8.75825 11.4163 9.45068 11.1295C10.1431 10.8427 10.735 10.357 11.1513 9.73381C11.5677 9.11064 11.79 8.37798 11.79 7.62849Z",
    fill: "#F0A51B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.0531 9.31199C12.7058 9.31199 12.371 9.36462 12.0557 9.4623C11.8687 8.92659 11.5198 8.46225 11.0573 8.13357C10.5948 7.80489 10.0416 7.62814 9.4742 7.62778C8.19251 7.62778 7.11967 8.5103 6.82199 9.69978C6.49562 9.44942 6.09606 9.31318 5.68472 9.31199C5.18221 9.31199 4.70028 9.51161 4.34494 9.86694C3.98961 10.2223 3.78999 10.7042 3.78999 11.2067C3.78999 11.461 3.84178 11.7027 3.93272 11.9242C3.74958 11.87 3.5599 11.8411 3.36894 11.8383C3.09247 11.8383 2.81871 11.8928 2.56329 11.9986C2.30786 12.1044 2.07578 12.2594 1.88029 12.4549C1.48548 12.8497 1.26367 13.3852 1.26367 13.9436C1.26367 14.5019 1.48548 15.0374 1.88029 15.4322C2.2751 15.827 2.81058 16.0488 3.36894 16.0488H13.0531C13.9465 16.0488 14.8033 15.6939 15.435 15.0622C16.0667 14.4305 16.4216 13.5738 16.4216 12.6804C16.4216 11.787 16.0667 10.9303 15.435 10.2986C14.8033 9.66687 13.9465 9.31199 13.0531 9.31199Z",
    fill: "#9AA5AF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5107_207618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.841797 0.470703)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloudy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cloudy.2606e37313790f75d53da2e3d0739e99.svg";